/* eslint-disable no-shadow */

enum EnumProductSubGroup {
  Employees = 'MitarbeiterInnen',
  Management = 'Management',
  Corporate = 'Firmenkunde / B2B',
  Retail = 'Privatkunde / B2C',
  Wealthy = 'vermögende Privatkunden',
}

export default EnumProductSubGroup;
